export enum EstadoPago {
  CALCULADO = 'CALCULADO',
  POR_PAGAR = 'POR_PAGAR',
  PAGADO = 'PAGADO',
  RECHAZADO = 'RECHAZADO',
  CANCELADO = 'CANCELADO',
  EXCLUIDO = 'EXCLUIDO',
  CONFIGURACION = 'CONFIGURACION',
  RECUPERADO = 'RECUPERADO',
}
